if (document.querySelector("#duvida")) {

    acordionList(".show-hiden-faq");
    function acordionList(dl) {
        const acordionList = document.querySelectorAll(dl);
        $(acordionList).on("click", function (e) {
            e.preventDefault();
        });
        function activeAcordion() {
            this.nextElementSibling.classList.toggle("active");
            this.nextElementSibling.classList.toggle("d-none");

            this.classList.toggle("active");
        }

        acordionList.forEach((item) => {
            item.addEventListener("click", activeAcordion);
        });
    }
}
